export default {
	user: [],
	users: [],
	collection: [],
	collections: [],
	recipe: [],
	recipes: [],
	ajaxCallsInProgress: 0
};


/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/